import { $$ } from './utils'

(() => {
  const faqs = $$('.faqs')
  if (!faqs.length) return

  faqs.forEach(faq => {
    let toggled = !!faq.dataset.toggled

    const questions = $$('.faq-question__toggle', faq)
    if (questions.length) {
      questions.forEach(question => {
        const answer = question.nextElementSibling

        question.addEventListener('click', () => {
          toggled = !toggled

          question.setAttribute('aria-expanded', toggled ? 'true' : 'false')
          $$('.faq-arrow', question).forEach(arrow => arrow.classList.toggle('hidden'))

          answer.setAttribute('aria-hidden', toggled ? 'false' : 'true')
          answer.classList.toggle('hidden')
        })
      })
    }
  })
})()
